import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6be35b27&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6be35b27')) {
      api.createRecord('6be35b27', component.options)
    } else {
      api.reload('6be35b27', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6be35b27&", function () {
      api.rerender('6be35b27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/affaire/index.vue"
export default component.exports